import './launchpad-embed-reset';
import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { KeycloakGate } from './auth/KeycloakGate';
import { queryClient } from './lib/query-client';
import { router } from './router/router';
import { backofficeEnv } from './config/env';
import './index.css';

const RouterDevtoolsLazy = import.meta.env.DEV
  ? lazy(() => import('./router/router-devtools').then((m) => ({ default: m.RouterDevtools })))
  : () => null;

document.title = backofficeEnv.appDisplayName;

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <KeycloakGate>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} context={{ query: queryClient }} />
        {import.meta.env.DEV ? (
          <Suspense fallback={null}>
            <RouterDevtoolsLazy />
          </Suspense>
        ) : null}
      </QueryClientProvider>
    </KeycloakGate>
  </StrictMode>
);
